import { render, staticRenderFns } from "./ActitiveTabcomponent.vue?vue&type=template&id=1280d709&scoped=true"
import script from "./ActitiveTabcomponent.vue?vue&type=script&lang=js"
export * from "./ActitiveTabcomponent.vue?vue&type=script&lang=js"
import style0 from "./ActitiveTabcomponent.vue?vue&type=style&index=0&id=1280d709&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1280d709",
  null
  
)

export default component.exports